import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { NgxPrimengGridModule } from 'ngx-primeng-grid';
import { NgxWrapperSharedModule } from '../ngx-wrapper-shared/ngx-wrapper.shared.module';
import { ButtonModule } from 'primeng/button';
import { NgxPrimengFormModule } from 'ngx-primeng-form';
import { ConfirmationService } from 'primeng/api';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { NgxCrudManageComponent } from './components/ngx-crud-manage/ngx-crud-manage.component';
import { NgxCrudManageDialogComponent } from './components/ngx-crud-manage-dialog/ngx-crud-manage-dialog.component';
import { NgxCrudManageLayoutComponent } from './components/ngx-crud-manage-layout/ngx-crud-manage-layout.component';
import { NgxCrudGridComponent } from './components/ngx-crud-grid/ngx-crud-grid.component';

@NgModule({
  declarations: [
    NgxCrudManageComponent,
    NgxCrudManageDialogComponent,
    NgxCrudManageLayoutComponent,
    NgxCrudGridComponent
  ],
  entryComponents: [NgxCrudManageDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPrimengGridModule,
    NgxWrapperSharedModule,
    ButtonModule,
    NgxPrimengFormModule,
    DynamicDialogModule,
    ConfirmDialogModule
  ],
  providers: [
    DialogService,
    ConfirmationService
  ],
  exports: [NgxCrudGridComponent, NgxCrudManageLayoutComponent, NgxCrudManageComponent]
})
export class NgxCrudLayoutModule { }
